const OFFSET = 50;

/**
 * This feature is used to set anchors behavior
 * 
 * @class Anchors
 * @param {Object} [query]
 */

export default class Anchors {
    constructor(query = 'a[href^="#"]') {
        const elements = document.querySelectorAll(query);
        if (!elements || !elements.length) return;

        this.elements = [...elements];
        this.query = query;

        this.offset = OFFSET;

        const header = document.querySelector('.site-header');
        if (header) this.offset = header.offsetHeight + OFFSET;

        this.init();
    }

    init() {
        this.handleResize();

        this.elements.forEach((el) => {
            el.addEventListener('click', this.handleClick.bind(this));
        });
    }

    handleResize() {
        window.addEventListener('resize', () => {
            const header = document.querySelector('.site-header');
            if (header) this.offset = header.offsetHeight + OFFSET;
        });
    }


    handleClick(event) {
        event.preventDefault();

        const el = event.currentTarget;

        const href = el.getAttribute('href');
        if (!href || href === '#') return;

        const id = href.slice(1);
        const target = document.getElementById(id);

        if (!target) return;

        window.scrollTo({
            top: target.getBoundingClientRect().top + window.scrollY - this.offset,
            behavior: 'smooth',
        });
    }
}
